<template>
  <button
    class="st-menu-item"
    :class="{ 'st-menu-item--danger': danger }"
    type="button"
    role="menuitem"
    :disabled="disabled"
  >
    <font-awesome-icon v-if="icon" :icon="['fas', icon]" class="st-menu-item__icon" />
    <span class="st-menu-item__label"><slot /></span>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  icon?: string;
  danger?: boolean;
  disabled?: boolean;
}>();
</script>

<style scoped>
.st-menu-item {
  display: flex;
  align-items: center;
  gap: var(--st-space-2);
  width: 100%;
  padding: var(--st-space-2) var(--st-space-3);
  border: none;
  border-radius: var(--st-radius-sm);
  background: transparent;
  color: var(--st-text);
  font-size: var(--st-text-sm);
  text-align: left;
  cursor: pointer;
  transition: var(--st-transition);
}
.st-menu-item:hover:not(:disabled) {
  background: var(--st-surface-hover);
}
.st-menu-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.st-menu-item--danger {
  color: var(--st-danger);
}
.st-menu-item--danger:hover:not(:disabled) {
  background: var(--st-danger-tint);
}
.st-menu-item__icon {
  width: 1rem;
  font-size: 0.9em;
  color: var(--st-text-subtle);
}
.st-menu-item--danger .st-menu-item__icon {
  color: var(--st-danger);
}
</style>
